import React from "react"
import { Spacer } from "@bw/bits"
import { Link } from "gatsby"
import styled from "styled-components"
import { breakpoints } from "../../../theme"

const activeStyle = {
  fontWeight: 700,
}

const Wrapper = styled.div`
  display: none;

  @media (min-width: ${breakpoints.medium}px) {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    font-weight: 500;
    margin-right: 40px;
  }

  > * + * {
    margin-left: 40px;
  }
`

const StyledTextItem = styled.div`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: currentColor;
  font-weight: 500;
  cursor: default;
`

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  color: currentColor;
  transition: opacity 0.25s ease-in-out;

  &:hover {
    opacity: 0.5;
  }
`

const Chevron = styled.div`
  border-left: 2px solid currentColor;
  border-bottom: 2px solid currentColor;
  transform: rotate(-45deg);
  display: inline-block;
  width: 0.5em;
  height: 0.5em;
  margin-left: 0.8em;
`

const DropCard = styled.div`
  font-weight: 400;
  color: #111;
  background-color: #fff;
  box-shadow: 0 -4px 30px -10px rgba(28, 27, 126, 0.15);
  border: 1px solid #eaeaef;
  border-radius: 10px;
  padding: 15px 20px;
  min-width: 200px;
`

const DropWrapper = styled.div`
  position: relative;
`

const DropContainer = styled.div`
  position: absolute;
  left: -20px;
  padding-top: 15px;
  opacity: 0;
  transform: translateY(-5px);
  visibility: hidden;
  pointer-events: none;
  transition: opacity 0.4s, transform 0.4s, visibility 0.4s;

  &.is-open {
    opacity: 1;
    transform: translateY(0);
    visibility: visible;
    pointer-events: auto;
  }
`

const Dropmenu = ({ item }) => {
  const [show, setShow] = React.useState(false)

  return (
    <DropWrapper
      onMouseEnter={() => setShow(true)}
      onMouseLeave={() => setShow(false)}
    >
      {item.to ? (
        <StyledLink to={item.to} activeStyle={activeStyle}>
          {item.label}
          <Chevron />
        </StyledLink>
      ) : (
        <StyledTextItem>
          {item.label}
          <Chevron />
        </StyledTextItem>
      )}
      <DropContainer className={show ? "is-open" : ""}>
        <DropCard className="dropcard">
          <Spacer gap="small">
            {item.nested.map(subItem => (
              <StyledLink key={subItem.page.to} to={subItem.page.to}>
                {subItem.page.label}
              </StyledLink>
            ))}
          </Spacer>
        </DropCard>
      </DropContainer>
    </DropWrapper>
  )
}

const DesktopMenu = ({ menu }) => {
  return (
    <Wrapper>
      {menu.map((item, i) =>
        item.nested.length > 0 ? (
          <Dropmenu key={i} item={item} />
        ) : (
          <StyledLink key={i} to={item.to} activeStyle={activeStyle}>
            {item.label}
          </StyledLink>
        )
      )}
    </Wrapper>
  )
}

export default DesktopMenu